const SET_REQUESTS_GRID_FILTERS = 'SET_REQUESTS_GRID_FILTERS'
const SET_ASSET_GRID_FILTERS = 'SET_ASSET_GRID_FILTERS'
const SET_HOME_PENDING_APPROVAL_GRID_FILTERS = 'SET_HOME_PENDING_APPROVAL_GRID_FILTERS'
const SET_HOME_MY_ORDERS_GRID_FILTERS = 'SET_HOME_MY_ORDERS_GRID_FILTERS'
const SET_HOME_FLEET_PROCESSING_GRID_FILTERS = 'SET_HOME_FLEET_PROCESSING_GRID_FILTERS'
const SET_ALL_PENDING_APPROVAL_GRID_FILTERS = 'SET_ALL_PENDING_APPROVAL_GRID_FILTERS'
const SET_BULK_ORDER_GRID_FILTERS = 'SET_BULK_ORDER_GRID_FILTERS'
const SET_CATALOG_MANAGEMENT_GRID_FILTERS = 'SET_CATALOG_MANAGEMENT_GRID_FILTERS'

const SET_REQUEST_TOTAL_ORDER_FILTERS = 'SET_REQUEST_TOTAL_ORDER_FILTERS'
const SET_REQUEST_SAVED_ORDER_FILTERS = 'SET_REQUEST_SAVED_ORDER_FILTERS'
const SET_REQUEST_PENDING_APPROVAL_FILTERS = 'SET_REQUEST_PENDING_APPROVAL_FILTERS'
const SET_REQUEST_FLEET_PROCESSING_FILTERS = 'SET_REQUEST_FLEET_PROCESSING_FILTERS'
const SET_REQUEST_COMPLETED_FILTERS = 'SET_REQUEST_COMPLETED_FILTERS'
const SET_REQUEST_RETURNED_FILTERS = 'SET_REQUEST_RETURNED_FILTERS'
const SET_REQUEST_PENDING_FLEET_FILTERS = 'SET_REQUEST_PENDING_FLEET_FILTERS'
const SET_REQUEST_REJECTED_FILTERS = 'SET_REQUEST_REJECTED_FILTERS'
const SET_REQUEST_CANCELLED_FILTERS = 'SET_REQUEST_CANCELLED_FILTERS'
const SET_DISPOSITION_PENALTY_FEES_FILTERS = 'SET_DISPOSITION_PENALTY_FEES_FILTERS'

const SET_ASSET_TOTAL_ORDER_FILTERS = 'SET_ASSET_TOTAL_ORDER_FILTERS'
const SET_ASSET_SAVED_ORDER_FILTERS = 'SET_ASSET_SAVED_ORDER_FILTERS'
const SET_ASSET_PENDING_APPROVAL_FILTERS = 'SET_ASSET_PENDING_APPROVAL_FILTERS'
const SET_ASSET_FLEET_PROCESSING_FILTERS = 'SET_ASSET_FLEET_PROCESSING_FILTERS'
const SET_ASSET_COMPLETED_FILTERS = 'SET_ASSET_COMPLETED_FILTERS'
const SET_ASSET_RETURNED_FILTERS = 'SET_ASSET_RETURNED_FILTERS'
const SET_ASSET_PENDING_FLEET_FILTERS = 'SET_ASSET_PENDING_FLEET_FILTERS'
const SET_ASSET_REJECTED_FILTERS = 'SET_ASSET_REJECTED_FILTERS'
const SET_ASSET_CANCELLED_FILTERS = 'SET_ASSET_CANCELLED_FILTERS'

const SET_BULK_ORDER_TOTAL_ORDER_FILTERS = 'SET_BULK_ORDER_TOTAL_ORDER_FILTERS'
const SET_BULK_ORDER_SAVED_ORDER_FILTERS = 'SET_BULK_ORDER_SAVED_ORDER_FILTERS'
const SET_BULK_ORDER_PENDING_APPROVAL_FILTERS = 'SET_BULK_ORDER_PENDING_APPROVAL_FILTERS'
const SET_BULK_ORDER_FLEET_PROCESSING_FILTERS = 'SET_BULK_ORDER_FLEET_PROCESSING_FILTERS'
const SET_BULK_ORDER_COMPLETED_FILTERS = 'SET_BULK_ORDER_COMPLETED_FILTERS'
const SET_BULK_ORDER_RETURNED_FILTERS = 'SET_BULK_ORDER_RETURNED_FILTERS'
const SET_BULK_ORDER_REJECTED_FILTERS = 'SET_BULK_ORDER_REJECTED_FILTERS'
const SET_BULK_ORDER_CANCELLED_FILTERS = 'SET_BULK_ORDER_CANCELLED_FILTERS'

const SET_ACQUISITION_CODE_MAINTENANCE_FILTERS = 'SET_ACQUISITION_CODE_MAINTENANCE_FILTERS'


const SET_CATALOG_MANAGEMENT_VEHICLE_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_VEHICLE_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_MOWER_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_MOWER_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_CONSTRUCTION_EQUIPMENT_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_CONSTRUCTION_EQUIPMENT_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_SNOW_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_SNOW_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_STANDARDIZED_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_STANDARDIZED_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_TRAILERS_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_TRAILERS_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_UTILITY_VEHICLE_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_UTILITY_VEHICLE_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_TREE_CARE_GRID_FILTERS = "SET_CATALOG_MANAGEMENT_TREE_CARE_GRID_FILTERS"
const SET_CATALOG_MANAGEMENT_JOB_TITLES_GRID_FILTERS = 'SET_CATALOG_MANAGEMENT_JOB_TITLES_GRID_FILTERS'

export {
    SET_REQUESTS_GRID_FILTERS,
    SET_ASSET_GRID_FILTERS,
    SET_HOME_PENDING_APPROVAL_GRID_FILTERS,
    SET_HOME_MY_ORDERS_GRID_FILTERS,
    SET_HOME_FLEET_PROCESSING_GRID_FILTERS,
    SET_ALL_PENDING_APPROVAL_GRID_FILTERS,
    SET_BULK_ORDER_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_GRID_FILTERS,
    SET_REQUEST_TOTAL_ORDER_FILTERS,
    SET_REQUEST_SAVED_ORDER_FILTERS,
    SET_REQUEST_PENDING_APPROVAL_FILTERS,
    SET_REQUEST_FLEET_PROCESSING_FILTERS,
    SET_REQUEST_COMPLETED_FILTERS,
    SET_REQUEST_RETURNED_FILTERS,
    SET_REQUEST_PENDING_FLEET_FILTERS,
    SET_REQUEST_REJECTED_FILTERS,
    SET_REQUEST_CANCELLED_FILTERS,
    SET_DISPOSITION_PENALTY_FEES_FILTERS,
    SET_ASSET_TOTAL_ORDER_FILTERS,
    SET_ASSET_SAVED_ORDER_FILTERS,
    SET_ASSET_PENDING_APPROVAL_FILTERS,
    SET_ASSET_FLEET_PROCESSING_FILTERS,
    SET_ASSET_COMPLETED_FILTERS,
    SET_ASSET_RETURNED_FILTERS,
    SET_ASSET_PENDING_FLEET_FILTERS,
    SET_ASSET_REJECTED_FILTERS,
    SET_ASSET_CANCELLED_FILTERS,
    SET_BULK_ORDER_TOTAL_ORDER_FILTERS,
    SET_BULK_ORDER_SAVED_ORDER_FILTERS,
    SET_BULK_ORDER_PENDING_APPROVAL_FILTERS,
    SET_BULK_ORDER_FLEET_PROCESSING_FILTERS,
    SET_BULK_ORDER_COMPLETED_FILTERS,
    SET_BULK_ORDER_RETURNED_FILTERS,
    SET_BULK_ORDER_REJECTED_FILTERS,
    SET_BULK_ORDER_CANCELLED_FILTERS,
    SET_ACQUISITION_CODE_MAINTENANCE_FILTERS,
    SET_CATALOG_MANAGEMENT_VEHICLE_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_MOWER_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_CONSTRUCTION_EQUIPMENT_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_SNOW_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_STANDARDIZED_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_TRAILERS_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_UTILITY_VEHICLE_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_TREE_CARE_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_JOB_TITLES_GRID_FILTERS
}